/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElDescriptions as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/descriptions/style/css';
import { ElDescriptionsItem as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/descriptions-item/style/css';
import { ElContainer as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/container/style/css';
import { ElFooter as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/footer/style/css';
import { ElMain as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/main/style/css';
import { ElHeader as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/header/style/css';
import { ElDropdown as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dropdown/style/css';
import { ElDropdownMenu as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/dropdown-menu/style/css';
import { ElDropdownItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/dropdown-item/style/css';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import { ElAside as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/aside/style/css';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7f4909f2"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hgtitle"
}, [/*#__PURE__*/_createElementVNode("p", null, "配合比数据系统")], -1));

const _hoisted_2 = {
  class: "header_right"
};
const _hoisted_3 = {
  class: "el-dropdown-link"
};
const _hoisted_4 = {
  style: {
    "margin-left": "5px"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("个人中心");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京ICP备14021466号-3", -1));

import mymenu from "./menu/index.vue";
import { useCounterStore } from "@/store/userInfo.js"; // import { useDark, useToggle, useStorage } from "@vueuse/core";

import { useRouter } from "vue-router";
import { Session } from "@/utils/storage.js";
import { logout } from "@/api";
import { ref } from "vue";
export default {
  __name: 'index',

  setup(__props) {
    const isCollapse = ref(false);
    const store = useCounterStore();
    const {
      name,
      account,
      phoneNumber
    } = store.getUserInfo;
    const router = useRouter(); // const isDark = ref(useDark());
    // const toggleDark = useToggle(isDark);
    // const vueuseColorScheme = useStorage("vueuse-color-scheme", null);
    // const theme = vueuseColorScheme.value === "auto" ? ref(false) : ref(true);

    const isShowCenter = ref(false);

    const loginOut = () => {
      ElMessageBox.confirm("确定要退出登录吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        logout().then(() => {
          router.push("/login");
          store.setUserInfo(null);
          Session.remove("token");
          Session.remove("client");
        });
      });
    }; // watch(
    //   theme,
    //   (newValue) => {
    //     if (newValue) {
    //       window.document.documentElement.setAttribute("data-theme", "light");
    //     } else {
    //       window.document.documentElement.setAttribute("data-theme", "dark");
    //     }
    //   },
    //   { immediate: true }
    // );


    return (_ctx, _cache) => {
      const _component_el_aside = __unplugin_components_0;

      const _component_Expand = _resolveComponent("Expand");

      const _component_Fold = _resolveComponent("Fold");

      const _component_el_icon = __unplugin_components_1;

      const _component_arrow_down = _resolveComponent("arrow-down");

      const _component_User = _resolveComponent("User");

      const _component_el_dropdown_item = __unplugin_components_2;

      const _component_SwitchButton = _resolveComponent("SwitchButton");

      const _component_el_dropdown_menu = __unplugin_components_3;

      const _component_el_dropdown = __unplugin_components_4;

      const _component_el_header = __unplugin_components_5;

      const _component_router_view = _resolveComponent("router-view");

      const _component_el_main = __unplugin_components_6;

      const _component_el_footer = __unplugin_components_7;

      const _component_el_container = __unplugin_components_8;

      const _component_el_descriptions_item = __unplugin_components_9;

      const _component_el_descriptions = __unplugin_components_10;

      const _component_el_dialog = __unplugin_components_11;

      return _openBlock(), _createBlock(_component_el_container, {
        class: "container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          class: _normalizeClass(["transiton aside", [_ctx.isDark ? 'leftline' : 'aside']]),
          style: _normalizeStyle({
            width: isCollapse.value ? '64px' : '208px'
          })
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createVNode(mymenu, {
            isCollapse: isCollapse.value
          }, null, 8, ["isCollapse"])])]),
          _: 1
        }, 8, ["class", "style"]), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_header, {
            class: _normalizeClass(["header", [_ctx.isDark ? 'modelDark' : '']])
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: "24px",
              onClick: _cache[0] || (_cache[0] = $event => isCollapse.value = !isCollapse.value)
            }, {
              default: _withCtx(() => [isCollapse.value ? (_openBlock(), _createBlock(_component_Expand, {
                key: 0
              })) : (_openBlock(), _createBlock(_component_Fold, {
                key: 1
              }))]),
              _: 1
            }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  onClick: _cache[1] || (_cache[1] = $event => isShowCenter.value = true)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_User)]),
                    _: 1
                  }), _hoisted_5]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  onClick: loginOut
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_SwitchButton)]),
                    _: 1
                  }), _hoisted_6]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(name)), 1), _createVNode(_component_el_icon, {
                class: "el-icon--right"
              }, {
                default: _withCtx(() => [_createVNode(_component_arrow_down)]),
                _: 1
              })])]),
              _: 1
            })])]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          }), _createVNode(_component_el_footer, {
            style: {
              "display": "flex",
              "align-item": "center",
              "justify-content": "center"
            }
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_dialog, {
          draggable: "",
          modelValue: isShowCenter.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => isShowCenter.value = $event),
          title: "个人中心"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions, {
            column: 2,
            size: _ctx.size,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "用户名"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(account)), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "电话号码"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(phoneNumber)), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["size"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }

};